export default function validationTourneeModele(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('LISTE_AFFICHAGE_WITHOUT_FACE') === 0) {
      messages.push({ message: 'detailTourneeModele.messages.error.listeAffichageWithoutFace' });
    }
    if (message.indexOf('FORBIDDEN_DELETE_LISTE_AFFICHAGE_WITH_TFS') === 0) {
      messages.push({ message: 'detailTourneeModele.messages.error.forbiddenDeleteWithTfs' });
    }
    if (message.indexOf('FORBIDDEN_UPDATE_TOURNEE_ARCHIVE') === 0) {
      messages.push({ message: 'addEditTourneeModele.errors.forbiddenUpdateWithfaces' });
    }
  });
}
